{
  "public-appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Rezervovat novou schůzku",
      "cancel": "Zrušit schůzku"
    }
  }
}
